import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles'

import GridItem from "../../components/Grid/GridItem";
import Card from '../../components/Card/Card';
import CardBody from "../../components/Card/CardBody";

import Button from "../../components/CustomButtons/Button";
import CustomInput from "../../components/CustomInput/CustomInput";

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { connect } from 'react-redux'
import * as actions from '../../store/actions/keepass';

const AddKeepassManual = props => {
    const classes = styles();
    const [isProcessing, setProcessing] = useState(false);
    const [title, setTitle] = useState('');
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [url, setUrl] = useState('');
    const [notes, setNotes] = useState('');

    const [titleError, setTitleError] = useState(false);
    const [userNameError, setUserNameError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);


    const handleTitle = (event) => {
        setTitleError(!event.target.value.length)
        setTitle(event.target.value)
    }

    const handleUserName = (event) => {
        setUserNameError(!event.target.value.length)
        setUserName(event.target.value)
    }

    const handlePassword = (event) => {
        setPasswordError(!event.target.value.length)
        setPassword(event.target.value)
    }

    const handleSubmit = (event) => {
        //send the data
        event.preventDefault();
        if (titleError || userNameError || passwordError || userName.length == 0 || title.length == 0 || password.length == 0)
            return props.showNotification({
                color: 'warning',
                message: "Title, Username and passwords are required.",
                time: 5000
            });
        setProcessing(true);
        props.addKeepassData(title, userName, password, notes, url, (err, response) => {
            setProcessing(false);
            if (err)
                return props.showNotification({
                    color: 'warning',
                    message: err.response.data.messsage,
                    time: 5000
                })

            props.showNotification({
                color: 'success',
                message: response.data.message,
                time: 5000
            });
            props.getKeepassDataWithUsers();
            props.closeModel();
        })

    }

    return (
        <GridItem xs={12}>
            <Card >
                <CardBody>
                    <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>

                        <GridItem xs={12}>
                            <FormControl className={classes.formControl} fullWidth>
                                <InputLabel id="title-select-input">Title/User</InputLabel>
                                <Select
                                    labelId="title-select-input"
                                    id="title-select"
                                    value={title}
                                    onChange={handleTitle}
                                >
                                    {props.users.map(user => <MenuItem value={user}>{user}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </GridItem>

                        <GridItem xs={12}>
                            <CustomInput
                                labelText="User name"
                                id="userName"
                                inputProps={{
                                    value: userName,
                                    onChange: handleUserName,
                                    error: userNameError
                                }}
                                formControlProps={{
                                    fullWidth: true,
                                    className: classes.root
                                }}
                            />
                        </GridItem>

                        <GridItem xs={12}>
                            <CustomInput
                                labelText="Password"
                                id="password"
                                inputProps={{
                                    value: password,
                                    onChange: handlePassword,
                                    error: passwordError
                                }}
                                formControlProps={{
                                    fullWidth: true,
                                    className: classes.root
                                }}
                            />

                        </GridItem>

                        <GridItem xs={12}>
                            <CustomInput
                                labelText="URL"
                                id="url"
                                inputProps={{
                                    value: url,
                                    onChange: (event) => setUrl(event.target.value),
                                }}
                                formControlProps={{
                                    fullWidth: true,
                                    className: classes.root
                                }}
                            />

                        </GridItem>

                        <GridItem xs={12}>
                            <CustomInput
                                labelText="Notes"
                                id="notes"
                                inputProps={{
                                    value: notes,
                                    onChange: (event) => setNotes(event.target.value),
                                }}
                                formControlProps={{
                                    fullWidth: true,
                                    className: classes.root
                                }}
                            />

                        </GridItem>
                        <GridItem xs={12} className={classes.logoHolder}>
                            <div className={classes.buttonHolder}>
                                <Button type="submit" color="primary"
                                    disabled={isProcessing}
                                >Add</Button>
                            </div>
                        </GridItem>
                    </form>
                </CardBody>
            </Card>
        </GridItem>
    )
}

const styles = makeStyles({});

const mapStateToProps = state => {
    return {
        users: state.keepass.users
    }
}

export default connect(mapStateToProps, actions)(AddKeepassManual)
